type NumberFormatter = (
  decimals: number,
  fixed?: boolean
) => (value: number) => string;

export interface TrendDisplay {
  text: string;
  color: "success.main" | "error.main" | "text.primary";
}

/**
 * Format a percentage trend for display. The sign, colour and text are all
 * derived from the value rounded to the displayed precision, so a value that
 * rounds to zero reads as a neutral "0.0%" rather than a signless figure shown
 * in the down colour.
 */
export const formatTrend = (
  trendPercentage: number,
  formatNumber: NumberFormatter
): TrendDisplay => {
  const rounded = Math.round(trendPercentage * 10) / 10;
  const sign = rounded > 0 ? "+" : "";
  const text = `${sign}${formatNumber(1, true)(trendPercentage)}%`;
  const color =
    rounded > 0 ? "success.main" : rounded < 0 ? "error.main" : "text.primary";
  return { text, color };
};
